import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '1.5rem',
        color: '#7c3aed'
      }}>
        <div>
          <div style={{ marginBottom: '1rem' }}>🔄</div>
          Cargando...
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    loginWithRedirect({
      appState: {
        returnTo: window.location.pathname + window.location.search
      }
    });
    return null;
  }

  return children;
};

export default ProtectedRoute;
